<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  color: string;
}>();
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1756.000000 1755.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,1755.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        :fill="color"
        d="M8325 17529 c-1888 -100 -3678 -800 -5135 -2008 -521 -432 -1016
-954 -1428 -1506 -823 -1102 -1374 -2380 -1606 -3725 -42 -239 -78 -516 -103
-790 -23 -247 -26 -1123 -5 -1370 67 -791 205 -1467 442 -2165 568 -1674 1634
-3137 3065 -4205 1109 -829 2399 -1381 3760 -1610 489 -82 807 -110 1338 -117
519 -7 831 10 1277 67 2704 351 5096 1956 6462 4335 1512 2633 1543 5887 81
8553 -188 343 -441 735 -675 1047 -1498 1991 -3752 3249 -6218 3469 -384 35
-885 45 -1255 25z m1090 -48 c237 -20 428 -41 639 -72 353 -50 952 -177 962
-204 4 -10 -312 -1213 -321 -1223 -2 -2 -68 12 -147 32 -406 99 -853 166
-1303 196 -193 13 -727 13 -920 0 -448 -30 -896 -97 -1294 -195 -80 -20 -148
-32 -151 -28 -14 15 -330 1217 -323 1224 5 3 76 23 158 43 531 127 1034 202
1585 235 186 12 945 6 1115 -8z m-2901 -298 c37 -116 323 -1210 318 -1214 -4
-4 -65 -24 -137 -44 -1114 -322 -2152 -919 -3025 -1738 l-135 -127 -450 450
-450 451 125 122 c582 566 1357 1114 2110 1492 493 247 1084 475 1590 614 49
13 48 13 54 -6z m4700 -23 c839 -241 1682 -635 2426 -1133 422 -284 779 -570
1178 -946 l122 -116 -452 -452 -452 -452 -135 127 c-907 850 -1911 1419 -3116
1765 -27 8 -49 19 -48 23 0 5 73 280 162 610 89 331 161 604 161 608 0 9 5 8
154 -34z m-1804 -999 c355 -35 686 -86 984 -152 212 -47 286 -67 286 -79 0
-11 -571 -2142 -576 -2152 -2 -3 -37 2 -76 13 -239 62 -606 118 -913 140 -208
14 -650 6 -855 -16 -192 -20 -471 -67 -647 -108 -125 -29 -143 -32 -148 -18
-27 89 -574 2146 -571 2149 8 7 225 60 381 92 293 61 627 108 910 130 77 6
158 12 180 14 86 8 937 -3 1045 -13z m-2266 -1325 c290 -1081 291 -1085 250
-1086 -24 0 -367 -115 -499 -167 -165 -65 -515 -233 -670 -323 -338 -194 -705
-467 -961 -712 -56 -54 -105 -98 -110 -98 -5 0 -364 355 -799 790 l-789 789
34 37 c65 67 320 296 458 412 628 523 1362 949 2137 1240 315 117 646 218 656
199 4 -7 136 -493 293 -1081z m3731 1050 c792 -230 1578 -618 2270 -1119 247
-179 628 -500 795 -671 l65 -66 -792 -792 -792 -792 -103 96 c-500 462 -1019
792 -1634 1038 -119 48 -372 134 -486 165 l-56 16 8 32 c5 18 135 503 290
1079 154 576 280 1050 280 1053 0 4 8 4 18 1 9 -3 71 -21 137 -40z m-7436
-1925 c-35 -38 -109 -118 -163 -178 -765 -833 -1330 -1851 -1656 -2981 -17
-59 -25 -73 -38 -69 -9 2 -282 75 -607 162 -324 87 -594 161 -599 166 -22 20
163 593 313 967 409 1023 1056 2022 1805 2790 l110 113 450 -450 450 -450 -65
-70z m11652 847 c282 -300 451 -500 671 -793 485 -643 880 -1356 1168 -2104
137 -355 289 -840 267 -852 -16 -9 -1219 -331 -1222 -327 -1 2 -19 61 -40 133
-326 1124 -920 2157 -1748 3038 l-120 129 449 449 c247 247 451 449 454 449 3
0 58 -55 121 -122z m-10393 -1963 c232 -231 422 -424 422 -429 0 -5 -44 -54
-97 -110 -246 -255 -521 -626 -713 -960 -89 -155 -258 -506 -323 -671 -52
-132 -167 -475 -167 -499 -1 -42 3 -43 -1091 249 -591 158 -1078 291 -1082
295 -10 9 61 254 134 467 348 1005 887 1894 1627 2681 l125 134 371 -369 c204
-202 561 -557 794 -788z m9604 875 c667 -745 1177 -1614 1496 -2552 76 -221
137 -437 126 -447 -8 -8 -2134 -581 -2154 -581 -5 0 -12 15 -15 33 -4 17 -30
102 -57 187 -229 714 -614 1370 -1131 1930 l-115 125 791 792 792 793 68 -68
c38 -37 127 -132 199 -212z m-5122 159 c1016 -74 1999 -462 2800 -1104 305
-245 611 -556 855 -870 1026 -1320 1334 -3094 815 -4700 -143 -441 -380 -924
-638 -1300 -424 -617 -961 -1123 -1602 -1510 -178 -107 -556 -294 -745 -368
-1462 -573 -3106 -448 -4452 339 -547 320 -1038 746 -1438 1248 -588 740 -965
1658 -1070 2606 -106 969 71 1973 501 2831 260 522 560 936 973 1349 269 268
494 452 801 655 945 624 2050 908 3200 824z m-8207 -3023 c334 -90 609 -165
612 -167 2 -3 -9 -56 -25 -119 -78 -302 -153 -748 -184 -1090 -77 -832 -15
-1678 182 -2483 16 -64 27 -119 23 -121 -9 -6 -1206 -326 -1218 -326 -21 0
-126 470 -183 811 -171 1036 -150 2160 61 3179 44 212 110 480 117 480 4 0
280 -74 615 -164z m16256 127 c287 -1066 355 -2317 190 -3458 -57 -390 -182
-975 -210 -975 -13 0 -1213 321 -1218 326 -3 3 12 73 32 157 89 368 145 716
184 1137 21 233 24 937 5 1165 -38 451 -110 895 -203 1258 -11 44 -18 84 -16
90 2 8 1179 333 1219 336 4 1 12 -16 17 -36z m-14534 -588 c567 -152 1046
-280 1066 -285 l36 -10 -34 -142 c-41 -177 -88 -456 -108 -648 -22 -205 -30
-647 -16 -855 22 -308 78 -674 140 -913 14 -53 16 -74 8 -77 -28 -10 -2145
-575 -2154 -575 -10 0 -76 270 -118 489 -180 934 -176 1922 11 2860 29 149 85
388 99 429 3 8 13 11 22 8 10 -3 482 -130 1048 -281z m13284 158 c92 -387 149
-730 186 -1133 22 -233 30 -789 16 -1035 -28 -473 -90 -905 -193 -1328 -37
-158 -42 -169 -62 -165 -31 6 -2140 571 -2145 575 -2 1 10 62 27 135 177 762
179 1587 6 2336 -20 85 -33 156 -30 159 5 5 2138 581 2158 582 3 1 20 -56 37
-126z m-12154 -3180 c35 -127 120 -376 177 -518 235 -584 576 -1116 1026
-1603 l96 -103 -792 -792 -792 -792 -71 70 c-39 39 -121 126 -183 195 -676
751 -1188 1623 -1509 2565 -74 219 -141 444 -134 451 4 4 2136 580 2159 583 4
1 14 -25 23 -56z m11018 -232 c593 -159 1081 -292 1084 -295 16 -16 -149 -524
-257 -796 -354 -887 -851 -1660 -1538 -2390 l-89 -95 -569 562 c-313 309 -672
665 -798 792 l-229 230 97 101 c400 422 753 959 986 1505 66 153 169 440 206
572 16 57 29 103 29 103 0 0 485 -130 1078 -289z m-13202 -447 c330 -1129 919
-2154 1744 -3030 l123 -131 -446 -446 c-246 -246 -452 -447 -458 -447 -13 0
-291 298 -434 463 -747 872 -1311 1868 -1665 2942 -90 273 -141 452 -133 460
6 6 1221 334 1225 330 2 -1 21 -64 44 -141z m15566 -188 c4 -3 -76 -274 -129
-436 -399 -1226 -1101 -2393 -2003 -3327 l-104 -108 -452 452 -453 452 104
108 c532 548 1022 1260 1346 1953 164 349 298 697 394 1020 28 96 55 184 60
196 8 20 23 17 622 -143 337 -91 614 -166 615 -167z m-11924 -1507 c561 -515
1209 -895 1912 -1122 94 -30 185 -58 203 -62 17 -3 32 -9 32 -12 0 -16 -574
-2149 -580 -2156 -4 -5 -77 12 -161 37 -966 285 -1861 764 -2639 1411 -145
121 -356 312 -440 399 l-45 46 790 790 c435 435 791 790 793 790 2 0 62 -54
135 -121z m7935 -672 l793 -793 -123 -115 c-176 -164 -277 -253 -411 -362
-702 -575 -1496 -1013 -2357 -1300 -186 -62 -390 -121 -396 -115 -2 3 -132
483 -289 1069 -157 585 -287 1071 -290 1079 -4 12 19 22 98 44 132 37 419 140
572 206 546 233 1086 588 1500 983 55 53 102 96 105 97 3 0 362 -357 798 -793z
m-5602 -568 c535 -128 1190 -165 1760 -99 210 23 345 47 567 96 87 20 160 34
161 32 5 -5 576 -2142 576 -2154 0 -11 -219 -65 -462 -114 -910 -182 -1913
-183 -2843 -4 -175 34 -468 103 -477 112 -5 5 537 2062 567 2150 6 16 4 16
151 -19z m7217 -1258 c-917 -886 -2043 -1570 -3253 -1979 -228 -77 -507 -159
-514 -151 -5 5 -334 1222 -331 1226 0 1 57 18 126 38 1130 325 2239 965 3064
1767 l110 107 453 -452 453 -452 -108 -104z m-11135 853 c861 -803 1838 -1363
2972 -1705 90 -28 166 -51 167 -53 6 -6 -325 -1220 -334 -1223 -15 -5 -257 65
-473 137 -1058 350 -2060 918 -2915 1651 -175 150 -475 430 -475 443 0 12 881
896 893 896 4 0 79 -66 165 -146z m3383 -1814 c1146 -268 2381 -261 3499 20
63 16 115 28 116 27 4 -7 324 -1214 324 -1224 0 -7 -78 -30 -187 -56 -1291
-311 -2663 -322 -3962 -31 -168 38 -314 74 -319 79 -3 3 309 1180 324 1224 2
8 11 10 22 6 9 -4 92 -24 183 -45z"
      />
      <path
        :fill="color"
        d="M8640 17235 c0 -78 3 -95 15 -95 12 0 15 17 15 95 0 78 -3 95 -15 95
-12 0 -15 -17 -15 -95z"
      />
      <path
        :fill="color"
        d="M8710 17315 c0 -11 18 -15 85 -17 l85 -3 -85 -105 c-47 -57 -85 -110
-85 -117 0 -10 26 -13 100 -13 81 0 100 3 100 15 0 11 -17 15 -75 17 l-75 3
85 105 c46 58 84 111 85 118 0 9 -28 12 -110 12 -90 0 -110 -3 -110 -15z"
      />
      <path
        :fill="color"
        d="M8640 17080 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20
-8 0 -15 -9 -15 -20z"
      />
      <path
        :fill="color"
        d="M8793 16973 c-41 -8 -53 -40 -53 -135 l0 -88 -121 0 -120 0 3 -32 3
-33 118 -3 c106 -2 117 -4 117 -21 0 -11 -21 -32 -53 -53 -29 -20 -73 -53 -99
-75 l-46 -40 28 -17 c24 -13 60 -16 224 -16 l196 0 0 35 0 34 -147 3 -147 3
42 28 c23 15 48 27 57 27 11 0 15 11 15 45 l0 45 120 0 120 0 0 35 0 35 -120
0 -121 0 3 78 3 77 57 3 57 3 -16 34 c-15 32 -20 35 -57 34 -23 -1 -51 -4 -63
-6z"
      />
      <path
        :fill="color"
        d="M4703 16302 c-8 -5 -1 -24 23 -64 l33 -58 -22 -11 c-12 -7 -41 -23
-64 -36 l-42 -24 -31 55 c-32 56 -43 65 -55 46 -7 -12 122 -240 135 -240 20 0
18 21 -6 64 -15 26 -25 49 -23 50 10 9 111 66 117 66 4 0 19 -20 34 -45 19
-31 32 -43 43 -39 12 5 9 17 -20 68 -20 33 -50 87 -67 119 -34 60 -36 61 -55
49z"
      />
      <path
        :fill="color"
        d="M4416 16135 c-14 -13 -26 -29 -26 -34 0 -6 -7 -8 -15 -5 -35 14 -30
-11 17 -82 47 -72 52 -76 80 -70 50 10 88 43 88 78 0 35 -22 34 -30 -3 -3 -13
-18 -30 -33 -39 -24 -13 -28 -13 -44 3 -17 16 -15 19 30 60 51 47 55 61 31 95
-20 30 -64 29 -98 -3z m77 -17 c6 -19 -9 -44 -43 -68 l-30 -21 -9 23 c-9 23 2
56 23 70 18 12 54 9 59 -4z"
      />
      <path
        :fill="color"
        d="M4283 16059 c-8 -8 1 -32 34 -88 53 -91 60 -99 68 -80 4 12 -79 179
-89 179 -1 0 -7 -5 -13 -11z"
      />
      <path
        :fill="color"
        d="M4820 15933 c-29 -32 -70 -84 -93 -115 -44 -63 -40 -62 -149 -50
l-66 8 -17 -34 c-9 -19 -13 -37 -10 -41 4 -3 43 -8 86 -10 70 -3 79 -5 73 -20
-3 -9 -12 -39 -19 -68 -7 -28 -16 -56 -20 -62 -4 -7 8 -11 35 -11 24 0 42 5
44 13 2 6 12 41 22 76 24 84 79 168 167 258 39 40 69 74 66 76 -14 11 -59 37
-63 37 -2 0 -28 -26 -56 -57z"
      />
      <path
        :fill="color"
        d="M4892 15823 c-82 -99 -139 -207 -161 -304 l-9 -40 36 3 c32 3 37 7
44 38 17 71 50 130 73 130 34 0 35 -8 11 -76 -14 -39 -19 -65 -13 -67 6 -2
-39 -32 -100 -68 l-111 -64 14 -28 c17 -31 11 -33 139 42 38 23 73 41 78 41 4
0 12 -11 18 -24 11 -24 12 -24 45 -9 32 16 33 17 18 46 -9 16 -14 30 -12 31 2
2 45 27 96 56 50 29 92 56 92 60 0 4 -8 17 -17 28 -18 21 -18 21 -96 -25 -42
-25 -79 -44 -82 -42 -2 3 1 24 7 47 9 35 15 42 34 42 17 0 28 8 34 26 16 41
13 44 -42 45 -93 1 -96 7 -38 71 l51 57 -30 16 c-17 8 -32 15 -35 15 -2 0 -22
-21 -44 -47z"
      />
      <path
        :fill="color"
        d="M4403 15853 c-16 -6 -5 -33 13 -33 8 0 14 6 14 14 0 18 -11 25 -27
19z"
      />
      <path
        :fill="color"
        d="M12631 16332 c-24 -42 -43 -81 -43 -87 1 -27 24 -10 56 44 39 64 63
79 96 61 29 -15 25 -43 -15 -115 -29 -51 -33 -64 -20 -68 10 -5 26 14 55 66
22 40 40 78 40 85 0 7 -12 24 -26 39 -19 19 -33 24 -55 21 -22 -3 -28 -1 -27
10 7 40 -21 14 -61 -56z"
      />
      <path
        :fill="color"
        d="M12821 16245 c-62 -71 -29 -165 57 -165 52 0 92 41 99 102 5 40 2 47
-27 71 -46 39 -90 37 -129 -8z m123 -27 c22 -63 -49 -136 -100 -103 -30 19
-31 58 -4 103 18 29 25 33 58 30 30 -2 38 -8 46 -30z"
      />
      <path
        :fill="color"
        d="M13007 16121 c-20 -37 -37 -75 -37 -83 0 -23 44 -58 73 -58 32 0 32
0 6 -45 -16 -27 -19 -39 -11 -47 7 -7 13 -10 15 -7 12 16 127 220 129 230 2 6
-2 13 -9 16 -6 2 -24 -17 -39 -44 -15 -26 -34 -56 -42 -65 -21 -25 -58 -22
-76 4 -15 20 -13 26 19 85 38 69 42 83 22 83 -7 0 -29 -31 -50 -69z"
      />
      <path
        :fill="color"
        d="M13224 16050 c-28 -11 -39 -29 -26 -42 7 -7 19 -4 36 7 56 37 135
-20 122 -88 -9 -47 -46 -100 -77 -111 -52 -18 -119 20 -119 68 0 13 -7 26 -15
30 -11 4 -15 -2 -15 -27 0 -85 108 -136 186 -88 37 23 74 94 74 143 0 78 -92
138 -166 108z"
      />
      <path
        :fill="color"
        d="M12626 15975 c-9 -13 -16 -27 -16 -29 0 -3 18 -15 39 -26 22 -11 42
-24 46 -30 8 -12 -72 -130 -88 -130 -7 0 -25 9 -42 20 -40 26 -49 25 -64 -7
-13 -28 -12 -29 42 -59 15 -8 27 -17 27 -21 0 -3 -23 -41 -50 -85 -28 -43 -49
-82 -46 -87 3 -5 78 -50 167 -101 153 -88 163 -92 175 -75 22 30 17 42 -26 66
-22 13 -40 27 -40 32 0 7 38 62 70 100 4 4 35 -8 69 -28 35 -20 64 -35 65 -33
39 51 39 49 -22 86 -31 19 -59 36 -61 38 -3 2 42 61 91 118 4 6 28 -2 56 -17
l49 -27 12 27 c10 21 9 29 -1 38 -10 9 -233 140 -429 251 -4 2 -14 -7 -23 -21z
m209 -162 c36 -21 65 -41 65 -45 0 -4 -21 -35 -47 -68 l-46 -60 -56 32 c-31
17 -60 35 -65 39 -7 6 70 137 82 139 2 0 32 -17 67 -37z m-136 -188 c34 -20
61 -38 61 -40 0 -11 -73 -105 -81 -105 -5 0 -34 14 -63 31 l-54 30 36 59 c20
33 38 60 39 60 1 0 29 -16 62 -35z"
      />
      <path
        :fill="color"
        d="M1476 13232 c-5 -15 1 -40 18 -78 14 -31 26 -60 26 -65 0 -5 -15 -9
-32 -9 -59 0 -107 -12 -113 -28 -5 -13 6 -14 80 -8 l86 7 31 -71 c21 -48 35
-67 42 -60 7 7 3 27 -12 63 -31 74 -30 77 27 77 34 0 56 6 72 20 l24 20 -87
-6 c-71 -6 -88 -4 -89 7 0 8 -15 46 -33 84 -28 61 -34 67 -40 47z"
      />
      <path
        :fill="color"
        d="M1828 13078 c-16 -5 -28 -15 -28 -22 0 -37 109 -139 216 -201 36 -21
67 -42 70 -46 4 -7 -71 -149 -79 -149 -2 0 -38 15 -82 33 -44 19 -92 37 -106
40 -24 6 -28 14 -38 70 -6 35 -11 76 -11 90 0 28 -8 31 -47 21 -17 -5 -22 -12
-19 -28 3 -11 7 -47 10 -78 l6 -58 -32 0 c-42 0 -76 -18 -101 -51 -23 -32 -17
-56 25 -98 34 -33 48 -37 80 -20 19 10 19 12 -13 38 -45 38 -35 61 24 61 40 0
46 -3 57 -31 7 -17 30 -57 51 -89 20 -32 34 -62 31 -66 -4 -4 7 3 25 17 39 29
39 34 10 73 -13 17 -29 41 -36 53 l-12 23 52 -20 c57 -23 89 -39 89 -44 0 -3
-19 -36 -41 -76 -40 -68 -41 -72 -23 -85 25 -19 40 -19 48 0 3 8 10 15 16 15
5 0 10 -7 10 -15 0 -20 13 -19 60 5 29 15 40 27 40 44 0 33 -9 37 -41 21 -45
-24 -51 -18 -29 26 l21 40 43 -24 43 -24 17 27 c9 16 16 31 16 34 0 3 -18 15
-40 26 l-41 21 30 52 c16 29 41 72 55 97 14 25 26 48 26 51 0 4 -48 35 -107
70 -101 60 -170 116 -203 165 -13 18 -19 20 -42 12z"
      />
      <path
        :fill="color"
        d="M1325 12965 c-16 -15 -25 -36 -25 -55 0 -17 -5 -29 -11 -27 -6 1 -13
-2 -15 -8 -3 -10 146 -100 162 -98 25 4 8 25 -45 57 -64 39 -79 63 -61 96 15
29 43 25 115 -15 51 -29 64 -33 68 -20 5 10 -14 26 -66 55 -40 22 -78 40 -85
40 -7 0 -24 -11 -37 -25z"
      />
      <path
        :fill="color"
        d="M1895 12819 c-20 -34 -35 -63 -33 -64 7 -5 47 -25 51 -25 10 0 67
111 62 120 -3 6 -15 14 -25 20 -16 9 -24 2 -55 -51z"
      />
      <path
        :fill="color"
        d="M16003 13245 c-71 -40 -85 -56 -85 -90 0 -29 28 -65 50 -65 12 0 12
-3 2 -15 -10 -12 -9 -16 2 -20 22 -9 178 83 171 101 -7 18 -3 19 -72 -21 -66
-39 -83 -42 -105 -19 -33 32 -20 58 49 98 36 21 65 42 65 46 0 21 -20 17 -77
-15z"
      />
      <path
        :fill="color"
        d="M15714 13058 c3 -18 8 -53 11 -78 l6 -45 -17 30 c-9 17 -18 32 -20
34 -4 4 -161 -84 -178 -99 -5 -5 8 -38 28 -74 21 -37 34 -71 31 -76 -10 -16
-22 -4 -51 50 -24 44 -29 48 -48 38 -11 -6 -22 -12 -24 -14 -5 -3 152 -274
159 -274 3 0 14 6 24 14 18 13 18 15 -8 59 -30 50 -33 67 -14 67 6 0 27 -27
45 -60 18 -33 37 -60 43 -60 7 0 155 80 177 96 2 1 -4 17 -13 34 -19 38 -12
35 56 -22 26 -21 49 -38 52 -38 3 0 8 12 11 26 8 32 -21 67 -99 120 -49 34
-50 34 -55 12 -5 -20 -10 -16 -38 30 -18 29 -32 54 -32 57 0 3 9 5 21 5 15 0
19 5 15 18 -3 9 -8 50 -12 90 -4 40 -9 74 -13 76 -3 2 -19 6 -35 10 -28 7 -28
6 -22 -26z m-8 -183 c13 -25 15 -38 7 -46 -7 -7 -16 -1 -32 24 -24 40 -27 57
-8 57 8 0 22 -16 33 -35z m-70 -40 c13 -25 15 -38 7 -46 -7 -7 -16 -1 -32 24
-24 40 -27 57 -8 57 8 0 22 -16 33 -35z m143 -89 c24 -38 27 -56 8 -56 -17 0
-50 57 -43 76 8 20 12 18 35 -20z m-70 -40 c24 -38 27 -56 8 -56 -17 0 -50 57
-43 76 8 20 12 18 35 -20z"
      />
      <path
        :fill="color"
        d="M16087 13044 c-68 -39 -92 -64 -64 -66 17 -1 167 87 164 96 -7 20
-25 15 -100 -30z"
      />
      <path
        :fill="color"
        d="M15945 12960 c-3 -5 -4 -14 0 -20 8 -13 35 -1 35 16 0 16 -26 19 -35
4z"
      />
      <path
        :fill="color"
        d="M16205 12929 c-48 -28 -53 -29 -144 -22 -78 5 -93 4 -89 -8 3 -9 28
-16 77 -21 40 -3 75 -8 77 -11 3 -3 -9 -33 -26 -67 -21 -41 -29 -68 -24 -83 6
-18 14 -6 50 65 38 76 50 91 91 114 27 15 50 29 51 30 2 1 0 9 -5 17 -7 12
-16 10 -58 -14z"
      />
      <path
        :fill="color"
        d="M15382 12889 c-29 -16 -52 -32 -52 -36 0 -3 23 -46 51 -95 41 -72 49
-92 38 -99 -8 -5 -20 -7 -27 -4 -7 3 -5 -10 8 -35 19 -37 22 -39 45 -28 14 6
27 9 29 7 1 -2 19 -33 39 -69 60 -109 57 -106 103 -82 67 36 66 36 53 65 -14
30 -21 32 -50 15 -25 -16 -25 -17 -126 160 l-77 135 26 21 c25 20 25 22 9 48
l-17 27 -52 -30z"
      />
      <path
        :fill="color"
        d="M425 9040 c-65 -46 -74 -49 -132 -49 -56 -1 -63 -3 -63 -21 0 -18 7
-20 62 -20 58 0 66 -3 134 -50 79 -55 84 -57 84 -35 0 8 -29 34 -65 57 -35 24
-65 45 -64 48 0 3 29 23 64 45 40 25 65 46 65 57 0 25 -7 23 -85 -32z"
      />
      <path
        :fill="color"
        d="M1047 9033 c-4 -3 -7 -42 -7 -85 l0 -79 -27 3 c-27 3 -28 5 -31 71
l-3 67 -194 0 -195 0 0 -29 c0 -16 6 -31 15 -35 12 -4 15 -33 15 -171 0 -138
-3 -167 -15 -171 -9 -4 -15 -19 -15 -35 l0 -29 195 0 195 0 0 75 0 75 30 0 30
0 0 -90 0 -90 35 0 35 0 0 265 0 265 -28 0 c-16 0 -32 -3 -35 -7z m-337 -258
c0 -149 -2 -175 -15 -175 -13 0 -15 26 -15 175 0 149 2 175 15 175 13 0 15
-26 15 -175z m96 156 c-15 -16 -16 -23 -6 -43 22 -41 52 -68 87 -74 26 -5 33
-11 33 -30 0 -21 -5 -24 -38 -24 -63 0 -77 -18 -76 -94 0 -57 -2 -66 -18 -66
-17 0 -18 12 -18 175 l0 175 27 0 c25 0 25 -1 9 -19z m114 -20 c0 -34 -2 -38
-20 -34 -20 5 -60 48 -60 64 0 5 18 9 40 9 40 0 40 0 40 -39z m120 -126 c0
-21 -5 -25 -30 -25 -22 0 -30 5 -30 18 0 25 9 32 37 32 18 0 23 -5 23 -25z
m-120 -140 c0 -39 -3 -45 -21 -45 -16 0 -20 5 -16 19 3 12 -1 22 -9 25 -8 3
-14 15 -14 26 0 16 7 20 30 20 29 0 30 -2 30 -45z"
      />
      <path
        :fill="color"
        d="M275 8848 c-33 -17 -45 -40 -45 -80 0 -58 34 -88 100 -88 41 0 56 5
75 25 25 24 33 73 19 110 -15 37 -104 58 -149 33z m109 -39 c31 -24 33 -52 6
-79 -42 -42 -140 -15 -140 39 0 26 46 61 80 61 15 0 39 -9 54 -21z"
      />
      <path
        :fill="color"
        d="M246 8614 c-21 -20 -20 -73 1 -96 15 -17 15 -18 0 -18 -10 0 -17 -7
-17 -15 0 -12 18 -15 100 -15 82 0 100 3 100 15 0 11 -12 15 -44 15 -69 0
-106 11 -122 36 -12 17 -13 27 -4 43 9 19 20 21 90 21 64 0 80 3 80 15 0 22
-162 22 -184 -1z"
      />
      <path
        :fill="color"
        d="M17193 9145 c-37 -16 -53 -42 -53 -84 0 -94 152 -124 196 -39 42 81
-53 162 -143 123z m109 -42 c19 -17 23 -49 10 -70 -20 -31 -96 -37 -129 -10
-18 13 -16 62 3 81 21 21 92 21 116 -1z"
      />
      <path
        :fill="color"
        d="M16490 8930 l0 -110 250 0 250 0 0 30 0 30 -217 2 -218 3 -3 43 -3
42 135 0 136 0 0 -29 c0 -29 1 -30 30 -20 26 10 30 16 30 48 0 67 -12 71 -213
71 l-177 0 0 -110z"
      />
      <path
        :fill="color"
        d="M17252 8930 c-96 -6 -112 -18 -112 -82 0 -29 7 -46 27 -66 25 -25 28
-25 31 -8 2 10 -3 23 -12 28 -24 13 -21 75 4 88 17 9 22 7 30 -15 6 -15 10
-36 10 -48 0 -67 81 -92 109 -33 11 24 11 34 -2 67 -9 24 -11 39 -5 41 6 2 9
10 7 18 -3 12 -20 14 -87 10z m56 -58 c20 -26 15 -70 -9 -77 -12 -4 -24 -3
-29 2 -11 12 -29 91 -22 98 9 9 46 -5 60 -23z"
      />
      <path
        :fill="color"
        d="M16449 8759 c-15 -32 -15 -34 23 -88 29 -41 38 -64 35 -83 l-4 -28
144 0 c118 0 143 -3 143 -14 0 -22 15 -27 43 -17 23 9 24 12 16 58 -4 26 -8
56 -8 66 -1 31 36 2 67 -52 l27 -49 24 19 24 19 -18 41 c-23 50 -82 102 -135
118 -22 6 -92 14 -155 18 l-115 6 0 -36 0 -36 108 -3 107 -3 3 -37 3 -38 -108
0 -108 0 -33 63 c-19 34 -41 73 -51 85 l-17 23 -15 -32z"
      />
      <path
        :fill="color"
        d="M17070 8686 c0 -22 10 -28 115 -62 63 -21 112 -41 109 -44 -3 -3 -53
-21 -112 -41 -98 -32 -107 -38 -110 -62 l-3 -27 135 0 c113 0 136 2 136 15 0
12 -22 15 -112 17 l-113 3 113 38 c86 30 112 43 112 56 0 14 -26 27 -112 57
l-113 39 113 3 c90 2 112 5 112 17 0 12 -23 15 -135 15 l-135 0 0 -24z"
      />
      <path
        :fill="color"
        d="M1840 5039 c-74 -44 -141 -84 -149 -88 -13 -8 -12 -13 3 -36 10 -16
23 -24 32 -21 9 4 24 -12 44 -47 16 -29 30 -55 30 -59 0 -3 -26 -21 -57 -38
-32 -18 -60 -34 -62 -36 -5 -4 20 -64 26 -64 3 0 34 16 69 36 36 20 66 35 68
33 2 -2 18 -29 35 -61 20 -35 28 -59 21 -63 -14 -9 -12 -16 8 -43 l18 -23 139
80 c76 44 143 85 148 90 6 6 -9 41 -41 97 l-51 88 26 17 c15 10 30 16 35 13 5
-3 1 11 -9 30 -18 39 -29 43 -59 21 -10 -8 -22 -15 -25 -15 -4 0 -29 38 -55
85 -27 47 -51 85 -54 84 -3 0 -66 -37 -140 -80z m161 -77 c23 -43 23 -44 4
-58 -27 -20 -35 -15 -68 41 l-29 49 24 17 c27 21 33 17 69 -49z m-135 -19 c5
-10 20 -35 33 -55 l22 -37 -30 -15 -30 -16 -31 56 c-31 53 -31 56 -14 69 25
19 37 18 50 -2z m233 -150 l32 -57 -23 -18 c-27 -20 -31 -17 -71 54 l-27 47
22 15 c12 9 25 16 28 16 3 0 21 -26 39 -57z m-79 -124 c0 -6 -51 -31 -55 -27
-1 2 -17 29 -34 60 l-32 57 28 15 28 14 32 -56 c18 -32 33 -60 33 -63z"
      />
      <path
        :fill="color"
        d="M1335 4950 c-18 -20 -18 -29 1 -147 5 -35 3 -43 -15 -52 -27 -15 -56
0 -76 39 -19 38 -19 59 2 82 13 15 14 21 4 31 -10 9 -17 7 -33 -13 -15 -19
-19 -34 -15 -64 14 -99 117 -150 163 -81 15 23 15 30 0 91 -19 77 -15 104 19
104 44 0 83 -78 54 -107 -7 -7 -8 -20 -5 -30 7 -17 9 -16 27 6 31 38 23 87
-24 139 -26 28 -77 29 -102 2z"
      />
      <path
        :fill="color"
        d="M1430 4717 c-141 -83 -133 -78 -122 -89 7 -7 30 1 70 22 68 38 108
36 118 -5 8 -32 -2 -43 -70 -80 -51 -28 -68 -47 -48 -58 4 -3 39 15 77 38 62
38 70 47 73 76 3 28 -2 39 -28 60 l-31 26 30 13 c37 15 57 38 45 50 -5 5 -53
-18 -114 -53z"
      />
      <path
        :fill="color"
        d="M1483 4510 c-60 -36 -70 -91 -25 -140 15 -16 38 -31 52 -32 36 -4 32
24 -4 33 -49 13 -62 61 -27 93 19 17 21 16 57 -47 36 -63 38 -65 60 -50 34 22
47 67 30 108 -24 57 -83 72 -143 35z m109 -27 c22 -20 23 -56 2 -74 -13 -10
-17 -10 -25 2 -19 28 -39 68 -39 79 0 16 41 12 62 -7z"
      />
      <path
        :fill="color"
        d="M1612 4324 c-85 -48 -97 -58 -87 -73 4 -8 17 -5 40 9 89 55 124 60
145 20 16 -30 2 -48 -66 -86 -44 -25 -61 -40 -57 -50 7 -18 2 -19 86 31 37 21
70 48 73 58 8 26 -14 75 -38 83 -11 3 -17 11 -15 18 13 33 -13 29 -81 -10z"
      />
      <path
        :fill="color"
        d="M15448 4975 c-65 -112 -118 -208 -118 -212 0 -4 33 -26 72 -48 128
-71 220 -136 273 -190 l51 -54 29 19 28 18 -57 60 c-32 34 -73 71 -92 84 -38
26 -39 27 -21 52 12 16 18 15 84 -24 69 -39 72 -42 61 -66 -13 -29 -12 -30 30
-39 24 -5 32 -3 32 8 0 7 18 57 39 110 34 84 37 98 24 105 -12 7 -6 14 28 31
24 12 56 31 71 44 26 22 26 22 9 55 l-17 33 -44 -35 c-25 -18 -56 -37 -68 -41
-23 -7 -24 -6 -20 59 1 36 2 66 0 66 -2 0 -16 -7 -32 -15 -34 -17 -38 -10 -14
24 16 23 16 25 -7 42 -30 23 -21 34 -146 -183 l-96 -166 -51 29 c-28 16 -57
33 -65 38 -16 10 -21 0 100 208 49 84 89 156 89 161 0 7 -43 33 -53 32 -1 0
-55 -92 -119 -205z m334 -55 l3 -50 -32 0 c-18 0 -33 3 -33 8 0 12 44 92 52
92 3 0 8 -23 10 -50z m30 -116 c34 7 33 7 7 -54 l-21 -49 -32 16 c-17 9 -48
27 -69 40 -31 20 -36 27 -28 42 9 16 16 17 63 9 29 -5 65 -7 80 -4z"
      />
      <path
        :fill="color"
        d="M15577 4978 c-108 -186 -105 -177 -83 -193 11 -8 23 -15 27 -15 4 0
42 61 85 136 74 130 77 137 59 150 -10 8 -22 14 -27 14 -4 0 -32 -42 -61 -92z"
      />
      <path
        :fill="color"
        d="M16234 4962 c-16 -11 -34 -48 -34 -71 0 -12 -5 -20 -11 -18 -6 1 -13
-3 -16 -9 -3 -10 148 -104 168 -104 24 0 4 29 -33 50 -88 47 -106 80 -67 116
21 19 22 19 92 -19 53 -28 72 -35 78 -25 5 8 -12 24 -57 50 -64 37 -97 45
-120 30z"
      />
      <path
        :fill="color"
        d="M16111 4756 c-36 -38 -33 -92 7 -127 58 -52 119 -51 152 4 23 37 26
80 7 96 -20 16 -26 5 -20 -38 4 -32 1 -41 -18 -55 -26 -18 -55 -21 -64 -6 -3
6 9 37 27 70 28 52 31 62 18 70 -29 19 -85 11 -109 -14z m61 -57 c-15 -27 -30
-49 -34 -49 -14 0 -30 42 -24 66 7 27 39 44 68 36 15 -4 14 -9 -10 -53z"
      />
      <path
        :fill="color"
        d="M16011 4581 c-20 -20 -26 -39 -21 -70 1 -9 -13 -6 -45 12 -38 22 -47
24 -52 11 -3 -8 -4 -16 -2 -18 17 -12 223 -126 229 -126 29 0 13 23 -36 52
-66 38 -79 55 -71 90 11 41 34 41 105 3 45 -25 68 -33 75 -26 12 12 16 9 -51
50 -73 43 -104 49 -131 22z"
      />
      <path
        :fill="color"
        d="M15821 4405 c-58 -67 -34 -162 51 -204 84 -40 153 -17 183 62 15 40
15 47 1 80 -8 21 -19 37 -25 37 -16 0 -24 -21 -12 -33 18 -18 13 -81 -9 -105
-32 -34 -64 -37 -117 -11 -58 29 -87 77 -72 118 16 40 39 61 71 61 18 0 28 5
28 15 0 10 -10 15 -34 15 -26 0 -41 -8 -65 -35z"
      />
      <path
        :fill="color"
        d="M12625 2136 c-99 -58 -179 -109 -178 -114 3 -16 184 -325 210 -359
45 -62 81 -54 279 63 142 84 162 111 134 190 -9 27 -14 29 -46 26 -33 -4 -35
-6 -28 -31 11 -40 7 -62 -13 -77 -43 -33 -232 -134 -251 -134 -27 0 -110 139
-90 151 225 132 233 137 243 124 9 -10 16 -10 38 1 15 8 27 18 27 21 0 10
-134 243 -140 243 -3 0 -86 -47 -185 -104z m214 -91 c-11 -9 -233 -135 -240
-135 -14 0 -62 91 -53 99 5 5 61 38 124 75 l114 66 29 -51 c16 -27 28 -52 26
-54z"
      />
      <path
        :fill="color"
        d="M13044 1679 c-8 -14 11 -33 25 -25 11 7 4 36 -9 36 -5 0 -12 -5 -16
-11z"
      />
      <path
        :fill="color"
        d="M12905 1605 c-61 -32 -80 -79 -49 -123 17 -25 42 -27 125 -10 46 9
61 9 73 -1 52 -43 -49 -126 -107 -88 -16 10 -28 12 -38 6 -11 -7 -9 -13 11
-29 32 -25 71 -25 118 -1 67 34 82 105 30 144 -26 19 -28 19 -98 2 -64 -16
-73 -16 -87 -2 -21 21 -9 51 32 72 28 16 38 17 61 6 36 -16 57 2 28 24 -25 19
-61 19 -99 0z"
      />
      <path
        :fill="color"
        d="M13080 1611 c0 -4 21 -45 46 -89 32 -57 50 -79 60 -75 17 6 20 -1
-35 96 -25 42 -51 77 -58 77 -7 0 -13 -4 -13 -9z"
      />
      <path
        :fill="color"
        d="M4722 2165 c-7 -14 -12 -28 -12 -30 0 -2 28 -20 63 -39 94 -54 91
-51 78 -72 -28 -49 -24 -49 -119 5 -49 28 -95 51 -101 51 -11 0 -38 -47 -30
-54 2 -2 39 -23 82 -48 l79 -45 -31 -11 c-45 -16 -188 -35 -212 -29 -19 5 -21
3 -15 -25 3 -17 6 -34 6 -39 0 -15 101 -9 173 10 37 9 67 16 67 13 0 -2 -18
-34 -40 -72 -22 -38 -40 -73 -40 -78 0 -12 49 -34 60 -27 5 3 26 37 47 75 38
70 53 85 53 53 0 -28 50 -167 69 -190 15 -19 19 -19 49 -7 l33 14 -26 43 c-27
48 -65 150 -65 178 0 15 13 10 78 -27 42 -24 80 -44 83 -44 5 0 29 45 29 55 0
2 -42 27 -92 56 -51 29 -94 53 -96 55 -6 4 29 64 37 64 5 0 42 -19 82 -42 l72
-41 19 22 c10 13 18 26 18 30 0 3 -31 23 -69 45 -38 21 -75 42 -81 46 -9 6 -7
15 6 36 10 16 22 31 26 34 3 3 -9 15 -27 27 l-33 22 -21 -34 c-11 -19 -24 -35
-30 -35 -5 0 -40 18 -77 40 -38 22 -71 40 -75 40 -3 0 -11 -11 -17 -25z"
      />
      <path
        :fill="color"
        d="M4375 1758 c-3 -7 -20 -68 -39 -135 -28 -105 -31 -125 -19 -135 11
-9 31 5 104 78 49 49 89 85 89 81 0 -11 -48 -200 -56 -221 -4 -10 0 -18 11
-22 22 -9 221 186 202 198 -8 5 -42 -22 -96 -75 -60 -60 -81 -75 -75 -57 49
163 54 220 19 220 -6 0 -46 -36 -90 -80 -43 -44 -80 -78 -82 -76 -2 1 11 45
27 97 16 52 30 102 30 111 0 21 -19 34 -25 16z"
      />
      <path
        :fill="color"
        d="M4642 1474 c-29 -20 -52 -65 -52 -102 0 -35 39 -78 77 -85 27 -5 73
10 73 24 0 13 -24 17 -44 7 -40 -21 -90 32 -72 78 5 13 16 10 72 -21 73 -41
84 -38 84 22 0 45 -9 62 -41 78 -36 19 -69 19 -97 -1z m96 -26 c12 -12 17 -68
6 -68 -3 0 -25 12 -50 26 -36 21 -42 29 -33 40 14 17 61 18 77 2z"
      />
      <path
        :fill="color"
        d="M4887 1463 c-4 -3 -7 -12 -7 -20 0 -17 26 -17 33 1 8 21 -11 35 -26
19z"
      />
      <path
        :fill="color"
        d="M4805 1324 c-33 -59 -44 -89 -37 -96 10 -10 24 7 85 113 21 38 24 49
13 58 -10 8 -23 -8 -61 -75z"
      />
      <path
        :fill="color"
        d="M8625 1104 c-8 -20 -15 -40 -15 -44 0 -4 -18 -34 -40 -68 l-39 -61
29 -21 29 -21 37 56 c36 54 38 55 85 55 l49 0 0 -60 0 -60 -115 0 -115 0 0
-35 0 -35 115 0 115 0 0 -110 0 -110 35 0 35 0 0 110 0 110 115 0 115 0 0 35
0 35 -115 0 -115 0 0 60 0 60 95 0 95 0 0 35 0 35 -165 0 -165 0 11 26 c11 32
13 30 -28 39 -30 6 -33 4 -48 -31z"
      />
      <path
        :fill="color"
        d="M8520 505 c0 -4 16 -65 35 -136 19 -71 35 -132 35 -134 0 -3 8 -5 18
-5 15 0 25 22 52 120 18 66 34 120 35 120 1 0 17 -54 35 -120 45 -164 55 -162
103 16 21 76 35 139 33 142 -17 17 -35 -18 -55 -112 -22 -97 -41 -144 -41
-100 0 10 -12 62 -27 116 -23 88 -28 99 -47 96 -20 -3 -36 -45 -86 -228 -1 -3
-14 47 -29 110 -20 87 -31 116 -44 118 -9 2 -17 0 -17 -3z"
      />
      <path
        :fill="color"
        d="M8900 346 c0 -64 4 -88 16 -100 20 -21 73 -20 96 1 17 15 18 15 18 0
0 -10 7 -17 15 -17 12 0 15 18 15 100 0 82 -3 100 -15 100 -11 0 -15 -13 -15
-54 0 -92 -34 -141 -80 -116 -17 9 -20 21 -20 90 0 64 -3 80 -15 80 -12 0 -15
-16 -15 -84z"
      />
    </g>
  </svg>
</template>
